import React, { useState, useContext, useRef } from "react";

import { Form } from '@unform/web';
import { SubmitHandler, FormHandles } from '@unform/core';

import { BsArrowRight, BsFillKeyFill, BsArrowCounterclockwise } from 'react-icons/bs';

import Input from "../../../../components/Form/Input";
import * as Yup from 'yup';
import getValidationErrors from "../../../../helpers/getValidateErrors";
import { getSingleErrorMessage } from "../../../../helpers/getSingleErrorMessage";
import { useAuth } from "../../../../hooks/auth";
import { ToastContext } from "../../../../contexts/toast/toastContext";
import { ILogin } from "../../../../common/interfaces/signIn.interfaces";
import { Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import logoAlumisoft from '../../../../assets/imgs/logos/2025/alumisoft.svg';
import EsquadGroup from '../../../../assets/imgs/logos/2025/esquadgroup_cinza.svg';
import "../login.css"

interface Props {
    responsive:boolean
}

const FormLogin: React.FC<Props> = ({responsive}) => {
 // Refs
 const formRef = useRef<FormHandles>(null);

 //Contexts
 const { signIn } = useAuth();
 const toastContext = useContext(ToastContext);

 //States
 const [loading, setLoading] = useState(false);

 // Handles
 const handleSubmit: SubmitHandler<ILogin> = async (login) => {
   try {
      
     setLoading(true);
     formRef.current?.setErrors({});

     const schema = Yup.object().shape({
       login: Yup.string().required('O campo é obrigatório.'),
       senha: Yup.string().required('Digite sua senha.')
     });
     await schema.validate(login, { abortEarly: false });

     await signIn(login);

   } catch (error) {
     if (error instanceof Yup.ValidationError) {
       formRef.current?.setErrors(getValidationErrors(error));
     }
     else {
       toastContext.notification(getSingleErrorMessage(error), "error");
     }
   } finally {
     setLoading(false);
   }
 }

    return(    
        <Form className={`formLogin ${responsive ? "img-background-login" : ""}`} ref={formRef} onSubmit={handleSubmit}>
            <Row className="formEntrar">
                <Col xs={12} sm={6} md={6} lg={10} xl={7} className={`formCol ${responsive ? "card mb-5" : ""}`}>
                    <Col className="text-center py-4">
                        <img src={logoAlumisoft} style={{width:"150px"}} alt="Alumisoft Logo"/>
                        <h3 className="py-3" style={{color:"#173c5b"}}>PORTAL DO CLIENTE</h3>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                        <h2 className="formSpan">Entrar</h2>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                        <label>E-mail</label>
                        <Input type="email" name="login" className="form-control col-" placeholder="Digite o seu e-mail de acesso" />
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12} className="my-3">
                        <label>Senha</label>
                        <Input type="password" name="senha" className="form-control" placeholder="Digite sua senha" />
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                        <button className="btn btn-primary btnEntrar">
                            <span>{loading ? "ENTRANDO..." : "ENTRAR"}</span>
                            <BsArrowRight className="ml-2"/>
                        </button>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12} className="mt-4">
                        <Link to="/Alumisoft/SolicitarAcesso">
                            <button className="btn formLink btnEntrar">
                            <span>Meu primeiro acesso</span>
                                <BsFillKeyFill className="ml-2"/>
                            </button>                        
                        </Link>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12} className="mt-2">
                        <Link to="/Alumisoft/esqueceuSuaSenha">
                            <button className="btn formLink btnEntrar">
                                Esqueceu a senha?
                                <BsArrowCounterclockwise className="ml-2"/>
                            </button>
                        </Link>
                    </Col>
                    <Col className="text-center py-4 mt-5">
                        <img src={EsquadGroup} style={{width:"160px"}} alt="Esquad Group"/>
                    </Col>
                </Col>
            </Row>
        </Form>
)}

export default FormLogin;